import { Outlet } from 'react-router-dom';

import { Drawer } from '../../shared/drawer';
import { Modal } from '../../shared/modals';

export const Main = () => (
    <Modal>
        <Drawer>
            <Outlet />
        </Drawer>
    </Modal>
);